/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum TIMEZONE_VALUES {
  UTC = "UTC",
  GMT = "GMT",
  GMT_m_12 = "GMT-12",
  GMT_m_11 = "GMT-11",
  GMT_m_10 = "GMT-10",
  GMT_m_09 = "GMT-09",
  GMT_m_08 = "GMT-08",
  GMT_m_07 = "GMT-07",
  GMT_m_06 = "GMT-06",
  GMT_m_05 = "GMT-05",
  GMT_m_04 = "GMT-04",
  GMT_m_03 = "GMT-03",
  GMT_m_02 = "GMT-02",
  GMT_m_01 = "GMT-01",
  GMT_p_01 = "GMT+01",
  GMT_p_02 = "GMT+02",
  GMT_p_03 = "GMT+03",
  GMT_p_04 = "GMT+04",
  GMT_p_05 = "GMT+05",
  GMT_p_06 = "GMT+06",
  GMT_p_07 = "GMT+07",
  GMT_p_08 = "GMT+08",
  GMT_p_09 = "GMT+09",
  GMT_p_10 = "GMT+10",
  GMT_p_11 = "GMT+11",
  GMT_p_12 = "GMT+12",
  GMT_p_13 = "GMT+13",
  GMT_p_14 = "GMT+14",
}
